import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ObterArquivoPoliticaPrivacidadeState } from "../../reducers/Sobre/obter-politica-privacidade.reducer";

export const selectObterArquivoPoliticaPrivacidadeState = createFeatureSelector<ObterArquivoPoliticaPrivacidadeState>('obterArquivoPoliticaPrivacidade');

export const selectDadosObterArquivoPoliticaPrivacidade = createSelector(
  selectObterArquivoPoliticaPrivacidadeState,
  (state: ObterArquivoPoliticaPrivacidadeState) => state.response
);

export const selectObterArquivoPoliticaPrivacidade = createSelector(
  selectObterArquivoPoliticaPrivacidadeState,
  (state: ObterArquivoPoliticaPrivacidadeState) => state
);

export const selectErrosObterArquivoPoliticaPrivacidade = createSelector(
  selectObterArquivoPoliticaPrivacidadeState,
  (state: ObterArquivoPoliticaPrivacidadeState) => state.error
);